module.exports = __webpack_public_path__ + "img/logo-os.2faf3757.svg";